import axios from '@/axios.js'

export default {
    getTracks: async (resortUuid, parameters) => {
        try {
            const response = await axios.editorapi.get(`v4/resorts/${resortUuid}/tracks`, { params: parameters })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
    exportTracks: async (resortUuid, parameters) => {
        try {
            const response = await axios.editorapi.get(`v4/resorts/${resortUuid}/export/tracks`, { params: parameters })
            return response.data.object
        } catch (error) {
            throw new Error(error)
        }
    },
}
